import { T_Integration, User } from "types";

// User query response type
export interface GetMeResponse {
  me: User;
}
export interface GetSettingResponse {
  me: Pick<User, "settings" | "_id" | "preferences" | "notifications"> & {
    meetingBotSettings: {
      followUpEmail: "all" | "external" | "internal" | "1:1" | "disabled";
      meetingNoteEmail: "all" | "external" | "internal" | "me" | "disabled";
      joinMeetings: "all" | "external" | "internal" | "1:1" | "disabled";
    };
  };
}

export interface GetUserSettingResponse {
  me: Pick<User, "settings" | "_id">;
}

export interface GetIntegrationsResponse {
  userIntegrations: {
    id: string;
    type: T_Integration;
  }[];
}

// User query variables type
export interface GetUserVariables {
  id: string;
}

export interface ChangeUserSettingsVariables {
  settings: {
    createNoteShortcut?: string;
    createTaskShortcut?: string;
    hasEmailNotification?: boolean;
    language?: string;
    timeZone?: string;
  };
}

export interface RemoveIntegrationVariableDto {
  integration: { id: string; type: T_Integration };
}
export enum ServiceName {
  InboxManagement = "inbox-management",
  DraftReply = "draft-reply",
  DailyPodcast = "daily-podcast",
  ActionItems = "action-items",
  MeetingPrep = "meeting-prep",
  MeetingAssistant = "meeting-assistant",
}

export interface GoogleOauthQueryDto {
  oauthData: {
    redirect: string;
    type: "login" | T_Integration;
    scopes: string[];
    userId?: string;
    services?: ServiceName[];
  };
  userId?: string;
}
